import { render, staticRenderFns } from "./ParcelamentoRelp.vue?vue&type=template&id=137cc9e2&"
import script from "./ParcelamentoRelp.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoRelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports